import { defineComponent as _defineComponent } from 'vue'
import { TimeSlotDetail } from '@/models/MeetingScheduler';
import IconFlash from '@/components/svg/flash.svg?inline';
import BCXPopover from '@/components/molecules/BCXPopover.vue';
import MeetingSectionItem from '@/components/meeting-scheduler/components/MeetingSectionItem.vue';
import useI18n from '@/mixins/useI18n';
import useFormattedDateTime from '@/mixins/useFormattedDateTime';
import useConflictPopover from '@/components/meeting-scheduler/composables/useConflictPopover';


export default /*#__PURE__*/_defineComponent({
  __name: 'MeetingSlotConflict',
  props: {
    timeSlot: null
  },
  setup(__props: any) {



const { tc } = useI18n();
const { getFormattedTimeRange } = useFormattedDateTime();
const {
  openSlotId, conflictMeetings, isLoading, open
} = useConflictPopover();

return { __sfc: true,tc, getFormattedTimeRange, openSlotId, conflictMeetings, isLoading, open, IconFlash, BCXPopover, MeetingSectionItem }
}

})